import { useState } from "react";

const useEcas = () => {
  const [idBlEcas, setIdBlEcas] = useState<number | undefined>();

  function openDialogUploadEcas(id: number) {
    setIdBlEcas(id);
  }

  function closeDialogUploadEcas() {
    setIdBlEcas(undefined);
  }

  return {
    idBlEcas,
    openDialogUploadEcas,
    closeDialogUploadEcas,
  };
};

export default useEcas;
